import React from 'react'
import { Grid, GridColumn, GridRow, Icon } from 'semantic-ui-react'
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'

import SwiperCore, { Navigation, Pagination } from 'swiper/core'

import 'swiper/swiper.min.css'
import {
  PLANNING_SERVICES_EMAIL,
  PLANNING_SERVICES_PHONE,
  PLANNING_SERVICES_PHONE_INTERNATIONAL,
} from '../../../environment'
import { PlacenameDataTypeProp } from '../slice'


import './PlacenameTab.css'

SwiperCore.use([Pagination, Navigation])

export default function PlacenameTab2({ placenameData }: PlacenameDataTypeProp) {

  function displayHistory() {
    const historyOrigin = placenameData.historyOrigin

    return (
      <React.Fragment>
        <GridRow className="placenameDetailsL1Row">
          <GridColumn width={16}>
            <div className="placenameDetailsFieldLabel">
              <p>History/Origin:</p>
            </div>
            <div className="placenameDetailsFieldValue">
              <p>{historyOrigin ? historyOrigin : 'UNAVAILABLE'}</p>
            </div>
          </GridColumn>

        </GridRow>


      </React.Fragment>
    )
  }

  function displayPlanningUnavailableError() {
    return (
      <React.Fragment>

        <GridColumn width={16}>
          <div className={'largePlanningError'}>
            <Icon name={'warning circle'} size={'large'}/>
            <p>Unavailable</p>
          </div>
          <p style={{ textAlign: 'center' }}>Planning Details not available online. Please contact Development
            Assessment Services
            on <a href={`mailto: ${PLANNING_SERVICES_EMAIL}`}>{PLANNING_SERVICES_EMAIL}</a> or phone: <a
              href={`tel:${PLANNING_SERVICES_PHONE_INTERNATIONAL}`}>{PLANNING_SERVICES_PHONE}</a></p>
        </GridColumn>

      </React.Fragment>
    )
  }

  function displayInternalError() {
    return (
      <React.Fragment>

        <GridColumn width={16}>
          <div className={'largePlanningError'}
               style={{ textAlign: 'center', fontWeight: 'bolder', color: 'indianred', fontSize: '3em' }}>
            <Icon name={'warning circle'} size={'large'}/>
            <p>Error</p>
          </div>
          <p style={{ textAlign: 'center' }}>Online plannings are currently unavailable. If your query is urgent
            please contact Valuation Services on <a
              href={`mailto: ${PLANNING_SERVICES_EMAIL}`}>{PLANNING_SERVICES_EMAIL}</a> or phone: <a
              href={`tel:${PLANNING_SERVICES_PHONE_INTERNATIONAL}`}>{PLANNING_SERVICES_PHONE}</a></p>
        </GridColumn>

      </React.Fragment>
    )
  }

  function displayFields() {
    if (placenameData.error && placenameData.errorType === 'INTERNAL_ERROR') {
      // internal error
      return (
        <React.Fragment>
          {displayInternalError()}
        </React.Fragment>
      )
    } else if (placenameData.error) {
      return (
        <React.Fragment>
          {displayPlanningUnavailableError()}
        </React.Fragment>
      )
    } else if (!placenameData.error) {
      return (
        <React.Fragment>
          {displayValidPlacenameFields()}
        </React.Fragment>
      )
    }
  }

  function displayValidPlacenameFields() {
    return (
      <React.Fragment>
        {displayHistory()}
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Grid className="placenameFieldsGrid" divided="vertically">
        {displayFields()}
      </Grid>
    </React.Fragment>
  )
}


